import {
  MultipleChoiceGroup,
  ResponseTypeEnum,
  TemplateNodeSchema,
  TemplateNodeTypeEnum,
} from '@ulysses-inc/harami_api_client'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'src/state/store'

const isUsed = (
  groupId: number,
  templateNodes: { [key: number]: TemplateNodeSchema },
): boolean =>
  Object.values(templateNodes).some(
    ({ type, question }) =>
      type === TemplateNodeTypeEnum.Question &&
      question?.responseType === ResponseTypeEnum.MULTIPLE_CHOICE &&
      question?.responseMultipleChoices?.some(group => group?.id === groupId),
  )

export const useIsMultipleChoiceGroupInUse = (
  multipleChoiceGroupForUpdate: MultipleChoiceGroup | undefined,
): boolean => {
  const templateNodes = useSelector(
    (state: RootState) => state.templatesState.templatePages.templateNodes,
  )

  const groupId = multipleChoiceGroupForUpdate?.id

  return useMemo(() => {
    if (!groupId || !templateNodes) {
      return false
    }

    return isUsed(groupId, templateNodes)
  }, [groupId, templateNodes])
}
